import HistoricalDocumentCalendar from '../components/layout/historical-documents-calendar-view/HistoricalDocumentCalendar';

function HistoricalDocumentsCalendarView() {
  return <HistoricalDocumentCalendar />;
}

export default HistoricalDocumentsCalendarView;
